import { useEffect, useRef } from 'react';
import { NativeEventEmitter, NativeModules } from 'react-native';
import { isWeb } from '../utils';

type NativeEvent =
  | 'onLoginComplete'
  | 'viewWillAppear'
  | 'viewDidAppear'
  | 'viewWillDisappear'
  | 'viewDidDisappear'
  | 'screenshot'
  | 'scrollToTop'
  | 'requestViewEvent'
  | 'requestAdReload';

const emitter = isWeb
  ? null
  : new NativeEventEmitter(NativeModules.ReactNativeBridge);

/**
 * - Native에서 발생하는 이벤트를 구독합니다.
 * - instanceId가 일치하는 경우에만 콜백을 실행합니다.
 * - 웹의 경우 동작하지 않습니다.
 */
export const useNativeEvent = (
  eventType: NativeEvent,
  instanceId: string,
  callback: () => void,
) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const instanceIdRef = useRef(instanceId);
  instanceIdRef.current = instanceId;

  useEffect(() => {
    if (!emitter) return;

    const subscription = emitter.addListener(
      eventType,
      (data: { instanceId: string }) => {
        if (data.instanceId === instanceIdRef.current) {
          callbackRef.current();
        }
      },
    );

    return () => subscription.remove();
  }, [eventType]);
};
